var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconXCircle = function SvgIconXCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "button-circle-x-small",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "8 8 8 8"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-x-small",
    transform: "translate(.95 .95)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    width: 1.616,
    height: 9.697,
    rx: 0.808,
    transform: "rotate(135 4.645 10.07)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    "data-name": "Rectangle 24",
    width: 1.616,
    height: 9.697,
    rx: 0.808,
    transform: "rotate(-135 7.213 5.828)"
  }))));
};
export { SvgIconXCircle as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iYnV0dG9uLWNpcmNsZS14LXNtYWxsIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjggOCA4IDgiPgogICAgPGcgaWQ9Imljb24teC1zbWFsbCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC45NSAwLjk1KSIgZmlsbD0iY3VycmVudENvbG9yIj4KICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlXzIzIiBkYXRhLW5hbWU9IlJlY3RhbmdsZSAyMyIgd2lkdGg9IjEuNjE2IiBoZWlnaHQ9IjkuNjk3IiByeD0iMC44MDgiCiAgICAgICAgICAgICAgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTUuMDUgMTMuOTA3KSByb3RhdGUoMTM1KSIgLz4KICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlXzI0IiBkYXRhLW5hbWU9IlJlY3RhbmdsZSAyNCIgd2lkdGg9IjEuNjE2IiBoZWlnaHQ9IjkuNjk3IiByeD0iMC44MDgiCiAgICAgICAgICAgICAgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOC4xOTMgMTUuMDUpIHJvdGF0ZSgtMTM1KSIgLz4KICAgIDwvZz4KPC9zdmc+Cg==";